import Repository from "../Repository";

const resource = "/product/otn";

export default {
  async get(otn_uuid) {
    return Repository.get(`${resource}/${otn_uuid}`);
  },

  async createOtn(payload) {
    return Repository.post(`${resource}`, payload);
  }
};
